<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      unit="店铺信息"
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @details-opened="onDetailsOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="105px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        基础信息
        <el-row class="row-border">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="店铺名称" prop="ShopName">
                {{ data.ShopName }}
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="店铺编号" prop="ShopCode">
                {{ data.ShopCode }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="所属商家" prop="BusiId">
                {{ data.BusiName }}
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="商街入驻店铺" prop="BstrName">
                <span v-if="data.BstrName&&data.BstrShopNo">
                  {{ data.BstrName + "-" + data.BstrShopNo }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="营业时间" prop="TradeTimebegin">
                <template v-if="data.TradeTimebegin.length==5">
                  {{ data.TradeTimebegin }} - {{ data.TradeTimeend }}
                </template>
                <template v-else>
                  {{ toTimeString(data.TradeTimebegin) }} - {{ toTimeString(data.TradeTimeend) }}
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="所在区域" prop="ShopPro">
                {{ data.DistrictNameChain }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="店铺类别" prop="ShopTypeId">
                {{ data.ShopTypeName }}
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="店铺域名" prop="ShopDomino">
                {{ data.ShopDomino }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="实体店地址" prop="ShopAddress">
                {{ data.ShopAddress }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="主营描述" prop="TradeDescribe">
                <el-tag type="primary" size="small" v-for="(item,index) in data.TradeDescribe.split(',')" :key="index" style="margin-right:10px;">{{item}}</el-tag>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="file-form">
            <el-col :span="24">
              <el-form-item label="实体图片" prop="EntityPhoto">
                <div v-if="data.EntityPhoto != ''">
                  <el-image
                    class="imgUrl"
                    fit="cover"
                    v-for="(item, index) in imgUrLs"
                    :key="index"
                    :src="item"
                    :preview-src-list="imgUrLs"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="isMB?'':'商城二维码'" :label-width="isMB?'0':''" prop="QrcodePhoto">
                <el-divider v-if="isMB">商城二维码</el-divider>
                <single-pic-upload
                  v-model="data.QrcodePhoto"
                  type="QrcodePhoto"
                  :uploadUrl="uploadUrl"
                  is-detail
                ></single-pic-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="序号" prop="OrderId">
                {{ data.OrderId }}
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="状态" prop="State">
                {{ data.OrderId==1?"启用":"停用" }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        联系方式
        <el-row class="row-border">
          <el-form-item :label="item.ContactName" v-for="(item,index) in formData" :class="{'is-required':item.IsShow}" :key="index">
            <el-row>
              <template v-if="item.LinkType=='链接'||item.LinkType=='文字'">
                <el-col :span="isMB?24:18">
                  {{ item.ContactDetail }}
                  <div style="visibility: hidden;" v-if="!item.ContactDetail">-</div>
                </el-col>
              </template>
              <template v-else-if="item.LinkType=='图片'">
                <el-col :span="isMB?24:18">
                  <el-divider v-if="isMB">{{item.ContactName}}</el-divider>
                  <single-pic-upload
                    v-model="item.ContactDetail"
                    type="ContactDetail"
                    :uploadUrl="uploadUrl"
                    is-detail
                  ></single-pic-upload>
                </el-col>
              </template>
              <template v-else-if="item.LinkType=='地图'">
                <el-col :span="isMB?24:18">
                  {{item.ContactDetail}}
                  <el-button icon="el-icon-location" type="primary" style="margin-left:10px;" @click.native="onMap(item)" 
                    title="地图展示" v-if="item.ContactDetail"></el-button>
                  <div style="visibility: hidden;" v-if="!item.ContactDetail">-</div>
                </el-col>
              </template>
              <el-col :span="isMB?24:4" :offset="isMB?0:2">
                显示在导航网站：<span :style="item.IsShow?'color:#009966;':'color:#f11;'">{{item.IsShow?"是":"否"}} </span>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>
        营销渠道链接类别
        <el-row class="row-border">
          <el-form-item :label="item.TypeName" v-for="(item,index) in formData2" :class="{'is-required':item.IsShow}" :key="index">
            <el-row>
              <el-col :span="isMB?24:18">
                <div>{{item.LinkDetail}}</div>
                <div style="visibility: hidden;" v-if="!item.LinkDetail">-</div>
              </el-col>
              <el-col :span="isMB?24:4" :offset="isMB?0:2">
                显示在导航网站：<span :style="item.IsShow?'color:#009966;':'color:#f11;'">{{item.IsShow?"是":"否"}} </span>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>
      </template>
      <template slot="footer">
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
    <map-dialog ref="mapDialog" :selectable="false"></map-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import mapDialog from '@/components/common/maps/qq/mapDialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    mapDialog,
  },
  computed: {
    imgUrLs() {
      if (this.data.EntityPhoto) {
        var arr = this.data.EntityPhoto?.split(',');
        return arr.map(x => '/api' + x);
      } else return [];
    }
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        ShopName: "",
        ShopCode: "",
        BusiId: "",
        BusiName: "",
        BstrName: "",
        BstrShopNo: "",
        TradeTimebegin: "",
        TradeTimeend: "",
        ShopTypeId: "",
        ShopTypeName: "",
        ShopDomino: "",
        ShopAddress: "",
        TradeDescribe: "",
        EntityPhoto: "",
        QrcodePhoto: "",
        ShopPro: "",
        ShopCity: "",
        ShopArea: "",
        DataSource: 0,
        State: 1,
        Contacts: [],
        Links: [],
        DistrictNameChain: "",
      },
      formData: [],
      formData2: [],
      api: require("@/api/shop/shopdetail").default,
      isMB: this.$store.state.isMB,
      rules: {
        ShopName: [{ required: true, message: "店铺名称不能为空" }],
        BusiId: [{ required: true, message: "商家名称不能为空" }],
        ShopTypeId: [{ required: true, message: "店铺类别不能为空" }],
        TradeTimebegin: [{ required: true, message: "请选择开始营业时间" }],
        TradeTimeend: [{ required: true, message: "请选择结束营业时间" }],
        ShopDomino: [{ required: true, message: "店铺域名不能为空" }],
        ShopAddress: [{ required: true, message: "实体地址不能为空" }],
        TradeDescribe: [{ required: true, message: "主营描述不能为空" }],
        ShopPro: [{ required: true, message: "请选择省份" }],
        ShopCity: [{ required: true, message: "请选择城市" }],
        ShopArea: [{ required: true, message: "请选择行政区" }],
        EntityPhoto: [{ required: true, message: "实体照片不能为空" }],
        QrcodePhoto: [{ required: true, message: "商城二维码不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
    };
  },
  methods: {
    onCreateOpened(data) {

    },
    onDetailsOpened(data) {
      this.formData = data.Contacts.map(x => { return { ...x, T: x.RecordId?1:0, IsShow: x.State==1 }});
      this.formData2 = data.Links.map(x => { return { ...x, T: x.RecordId?1:0, IsShow: x.State==1 }});
    },
    onBeforeSave() {

    },
    onMap(item) {
      this.$refs.mapDialog.open({}).then(that => {
        if(item.ContactDetail) {
          var arr = item.ContactDetail.split(",");
          if(arr.length==2 && arr[0] && arr[1]) {
            that.setLocation({ lat: arr[0], lng: arr[1] });
            return;
          }
        }
        that.setLocation({ lat: 23.354349, lng: 116.681938 });
      });
    },
    toTimeString(v) {
      if(v) {
        var arr = v.split(":");
        return arr[0] + ":" + arr[1];
      }
    },
    onClosed() {
      this.formData = [];
      this.formData2 = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.imgUrl{
  margin-right: 8px;
  width: 80px;
  height: 80px;
  border-radius: 6px;
}
</style>
